import { useNavigate, useLocation } from 'react-router-dom';
import './BottomTabBar.css';

export default function BottomTabBar({ active }) {
  const navigate = useNavigate();
  const location = useLocation();

  // Определяем активную вкладку на основе текущего пути
  const currentActive = active || (() => {
    if (location.pathname.startsWith('/home')) return 'home';
    if (location.pathname.startsWith('/my-notes')) return 'notes';
    if (location.pathname.startsWith('/saved')) return 'bookmark';
    if (location.pathname === '/profile') return 'profile';
    return 'home';
  })();

  // Определяем иконки в зависимости от активности
  const homeIcon = currentActive === 'home' ? '/icons/home-active.svg' : '/icons/home-inactive.svg';
  const notesIcon = currentActive === 'notes' ? '/icons/notes-active.svg' : '/icons/notes-inactive.svg';
  const bookmarkIcon = currentActive === 'bookmark' ? '/icons/bookmark-active.svg' : '/icons/bookmark-inactive.svg';
  const profileIcon = currentActive === 'profile' ? '/icons/user-active.svg' : '/icons/user-inactive.svg';

  return (
    <div className="tabbar-wrap" role="navigation" aria-label="Основное меню">
      {/* Левый бар с 3 кнопками */}
      <div className="tabbar triple">
        <button
          className={`tab-btn ${currentActive === 'home' ? 'tab-btn--active' : ''}`}
          aria-label="Главная"
          onClick={() => navigate('/home')}
        >
          <img src={homeIcon} alt="" aria-hidden="true" />
        </button>
        <button
          className={`tab-btn ${currentActive === 'notes' ? 'tab-btn--active' : ''}`}
          aria-label="Заметки"
          onClick={() => navigate('/my-notes')}
        >
          <img src={notesIcon} alt="" aria-hidden="true" />
        </button>
        <button
          className={`tab-btn ${currentActive === 'bookmark' ? 'tab-btn--active' : ''}`}
          aria-label="Сохраненное"
          onClick={() => navigate('/saved')}
        >
          <img src={bookmarkIcon} alt="" aria-hidden="true" />
        </button>
      </div>

      {/* Правая круглая кнопка профиля */}
      <button
        className={`tabbar single ${currentActive === 'profile' ? 'tab-btn--active' : ''}`}
        aria-label="Профиль"
        onClick={() => navigate('/profile')}
      >
        <img src={profileIcon} alt="" aria-hidden="true" />
      </button>
    </div>
  );
}
